module.exports = __webpack_public_path__ + "static/img/live.8d61c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/live.png
// module id = Muhz
// module chunks = 174